/* ─── ROYAL POP STYLE — THEME JS ─── */// ─── CURSOR (GPU-composited: transform instead of left/top) ───
(function() {
  const cd = document.getElementById('cd');
  const cr = document.getElementById('cr');
  if (!cd || !cr) return;
  // Start at center off-screen; use transform for composited GPU animation
  cd.style.transform = 'translate(-200px,-200px)';
  cr.style.transform = 'translate(-200px,-200px)';
  let mx = -200, my = -200, rx = -200, ry = -200;
  document.addEventListener('mousemove', function(e) {
    mx = e.clientX; my = e.clientY;
    cd.style.transform = 'translate(' + (mx - 4) + 'px,' + (my - 4) + 'px)';
  }, { passive: true });
  (function animRing() {
    rx += (mx - rx) * 0.12;
    ry += (my - ry) * 0.12;
    cr.style.transform = 'translate(' + (rx - 18) + 'px,' + (ry - 18) + 'px)';
    requestAnimationFrame(animRing);
  })();
})();

// ─── SCROLL PROGRESS (GPU-composited: scaleX instead of width) ───
(function() {
  const pb = document.getElementById('pb');
  if (!pb) return;
  // Cache scrollHeight to avoid forced layout on every scroll tick
  let docH = document.documentElement.scrollHeight - window.innerHeight;
  window.addEventListener('resize', function() {
    docH = document.documentElement.scrollHeight - window.innerHeight;
  }, { passive: true });
  window.addEventListener('scroll', function() {
    if (docH <= 0) return;
    pb.style.transform = 'scaleX(' + (document.documentElement.scrollTop / docH) + ')';
  }, { passive: true });
})();

// ─── HERO PARALLAX ───
(function() {
  const heroBg = document.getElementById('heroBg');
  if (!heroBg) return;
  heroBg.classList.add('loaded');
  // Cache innerHeight — only a static image fallback is used when there's no video
  let vh = window.innerHeight;
  window.addEventListener('resize', function() { vh = window.innerHeight; }, { passive: true });
  window.addEventListener('scroll', function() {
    const y = window.scrollY;
    if (y < vh) {
      heroBg.style.transform = 'translateY(' + (y * 0.3) + 'px) scale(1)';
    }
  }, { passive: true });
})();

// ─── SCROLL REVEAL ───
(function() {
  const obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) { e.target.classList.add('on'); obs.unobserve(e.target); }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.rv').forEach(function(el) { obs.observe(el); });
})();

// ─── COUNTER ANIMATION ───
(function() {
  function animCount(el, target, duration) {
    duration = duration || 1800;
    let start = null;
    function step(ts) {
      if (!start) start = ts;
      const p = Math.min((ts - start) / duration, 1);
      el.textContent = Math.floor(p * target) + (p < 1 ? '' : '+');
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = target + '+';
    }
    requestAnimationFrame(step);
  }
  const countObs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        const t = parseInt(e.target.dataset.count);
        if (!isNaN(t)) animCount(e.target, t);
        countObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.5 });
  document.querySelectorAll('[data-count]').forEach(function(el) { countObs.observe(el); });
})();

// ─── CART AJAX (add to cart + redirect to cart) ───
(function() {
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.prod-add[data-variant-id]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const variantId = btn.dataset.variantId;
    if (!variantId) return;
    btn.disabled = true;
    btn.innerHTML = '<svg fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5" aria-hidden="true" style="width:14px;height:14px;color:#fff;animation:spin .6s linear infinite"><path d="M12 2a10 10 0 0 1 10 10"/></svg>';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function(item) {
      if (item.id) {
        window.location.href = '/cart';
      } else {
        btn.disabled = false;
        btn.innerHTML = '<svg fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
      }
    })
    .catch(function() {
      btn.disabled = false;
      btn.innerHTML = '<svg fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
    });
  });
})();

// ─── CROWN POSITION SELECTOR (design cadran + i18n + rend les boutons cliquables) ───
(function() {
  function fmt(cents) {
    return '€' + (cents / 100).toFixed(2).replace(/\.(\d)$/, '.$10');
  }
  var LABELS = {
    en: { a: "12 o'clock", b: "3 o'clock" },
    fr: { a: '12 h', b: '3 h' },
    de: { a: '12 Uhr', b: '3 Uhr' },
    nl: { a: '12 uur', b: '3 uur' }
  };
  function loc() {
    return (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  }
  function is12(value) { return String(value).indexOf('12') !== -1; }
  function label(value) {
    var m = LABELS[loc()] || LABELS.en;
    return is12(value) ? m.a : m.b;
  }
  function icon(value) {
    var dot = is12(value)
      ? '<circle class="pp-crown-dot" cx="12" cy="3.5" r="2.1"/>'
      : '<circle class="pp-crown-dot" cx="20.5" cy="12" r="2.1"/>';
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><circle class="pp-crown-face" cx="12" cy="12" r="7.4"/>' + dot + '</svg>';
  }
  function injectCSS() {
    if (document.getElementById('pp-crown-css')) return;
    var css = ''
      + '.pp-crown-buttons{display:flex;gap:10px;flex-wrap:wrap;}'
      + '.pp-crown-btn{display:inline-flex;align-items:center;gap:8px;padding:9px 15px;border:1px solid var(--gray,rgba(255,255,255,.22));border-radius:11px;background:transparent;color:var(--white,#fff);font-size:.82rem;font-weight:500;letter-spacing:.02em;line-height:1;cursor:pointer;transition:border-color .2s,background .2s,color .2s;}'
      + '.pp-crown-btn:hover{border-color:var(--gold,#c9a227);}'
      + '.pp-crown-btn.active{border-color:var(--gold,#c9a227);background:rgba(201,162,39,.12);color:var(--gold,#c9a227);}'
      + '.pp-crown-btn.sold-out{opacity:.4;cursor:not-allowed;text-decoration:line-through;}'
      + '.pp-crown-btn svg{width:19px;height:19px;flex:none;}'
      + '.pp-crown-face{stroke:currentColor;fill:none;stroke-width:1.4;}'
      + '.pp-crown-dot{fill:currentColor;stroke:none;}';
    var s = document.createElement('style');
    s.id = 'pp-crown-css';
    s.textContent = css;
    document.head.appendChild(s);
  }
  function init() {
    var btns = document.querySelectorAll('.pp-crown-btn');
    if (!btns.length) return;
    var variantInput = document.getElementById('pp-variant-id');
    var variants = window.__variants || [];
    if (!variantInput || !variants.length) return;

    // Masquer le sélecteur si les valeurs ne sont pas des positions horaires
    // (ex. "Top"/"Right" sur les kits acier/silicone) — ne touche pas au full steel (12/3 o'clock)
    var isClock = false;
    btns.forEach(function (b) { if (/clock/i.test(b.dataset.value || '')) isClock = true; });
    if (!isClock) {
      var wrap = btns[0].closest('.pp-option');
      if (wrap) wrap.style.display = 'none';
      return;
    }

    var atcBtn = document.getElementById('pp-atc');
    var priceEl = document.getElementById('pp-price');
    var crownNameEl = document.getElementById('pp-crown-name');
    var stickyPrice = document.getElementById('pp-sticky-price');

    injectCSS();

    // Design: mini-cadran (icône) + libellé traduit
    btns.forEach(function(btn) {
      var v = btn.dataset.value;
      btn.innerHTML = icon(v) + '<span>' + label(v) + '</span>';
      btn.setAttribute('aria-label', label(v));
    });

    function curVariant() {
      return variants.find(function(v) { return String(v.id) === String(variantInput.value); });
    }
    (function() {
      var cv = curVariant();
      if (crownNameEl && cv) crownNameEl.textContent = label(cv.option2);
    })();

    function applyVariant(variant) {
      variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = fmt(variant.price);
      if (atcBtn) {
        if (variant.available) {
          atcBtn.disabled = false;
          atcBtn.textContent = atcBtn.dataset.labelAdd + ' — ' + fmt(variant.price);
        } else {
          atcBtn.disabled = true;
          atcBtn.textContent = atcBtn.dataset.labelSold;
        }
      }
      if (stickyPrice) stickyPrice.textContent = fmt(variant.price);
    }

    btns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (this.classList.contains('sold-out')) return;
        var crownValue = this.dataset.value;
        var cv = curVariant();
        var curColor = cv ? cv.option1 : null;
        var variant = variants.find(function(v) { return v.option1 === curColor && v.option2 === crownValue; });
        if (!variant) return;
        btns.forEach(function(b) { b.classList.remove('active'); b.setAttribute('aria-checked', 'false'); });
        this.classList.add('active');
        this.setAttribute('aria-checked', 'true');
        if (crownNameEl) crownNameEl.textContent = label(crownValue);
        applyVariant(variant);
      });
    });

    document.querySelectorAll('.pp-swatch').forEach(function(sw) {
      sw.addEventListener('click', function() {
        setTimeout(function() {
          var cv = curVariant();
          var curCrown = cv ? cv.option2 : null;
          btns.forEach(function(b) {
            var on = b.dataset.value === curCrown;
            b.classList.toggle('active', on);
            b.setAttribute('aria-checked', on ? 'true' : 'false');
          });
          if (crownNameEl && curCrown) crownNameEl.textContent = label(curCrown);
        }, 0);
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ─── PROMO -10% : nettoie l'ancien texte panier/tiroir (deal banner -> -10%, masque la barre de progression) ───
(function () {
  var FULL = {
    fr: '<strong>Offre&nbsp;:</strong> 2 bracelets ou plus = -10% sur votre commande.',
    de: '<strong>Angebot:</strong> 2 oder mehr = -10% auf Ihre Bestellung.',
    nl: '<strong>Aanbieding:</strong> 2 of meer = -10% op uw bestelling.',
    en: '<strong>Offer:</strong> 2 or more = -10% off your order.'
  };
  function html() {
    var l = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    return FULL[l] || FULL.en;
  }
  function injectCSS() {
    if (document.getElementById('pp-promo15-css')) return;
    var s = document.createElement('style');
    s.id = 'pp-promo15-css';
    s.textContent = '.cd-progress,.cart-promo-banner,#exit-overlay{display:none !important;}';
    (document.head || document.documentElement).appendChild(s);
  }
  function apply() {
    document.querySelectorAll('.cd-promo--deal > div, .cart-promo--deal > div').forEach(function (el) {
      if (el.getAttribute('data-p15') === '1') return;
      el.innerHTML = html();
      el.setAttribute('data-p15', '1');
    });
  }
  function init() {
    injectCSS();
    apply();
    try {
      var obs = new MutationObserver(function () { apply(); });
      obs.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ─── FICHE PRODUIT : mention « montre non incluse » sous le titre « Commandez le vôtre » ───
(function () {
  var NOTE = {
    fr: 'Montre non incluse — bracelet uniquement.',
    de: 'Uhr nicht enthalten — nur das Armband.',
    nl: 'Horloge niet inbegrepen — alleen het bandje.',
    en: 'Watch not included — bracelet only.'
  };
  function txt() {
    var l = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    return NOTE[l] || NOTE.en;
  }
  function injectCSS() {
    if (document.getElementById('pp-order-note-css')) return;
    var s = document.createElement('style');
    s.id = 'pp-order-note-css';
    s.textContent = '.pp-order-note{margin:5px 0 0;font-size:.72rem;letter-spacing:.02em;font-style:italic;color:rgba(255,255,255,.55);}.pp-light .pp-order-note{color:rgba(40,35,28,.6);}';
    (document.head || document.documentElement).appendChild(s);
  }
  function apply() {
    document.querySelectorAll('.pp-order-title').forEach(function (t) {
      var next = t.nextElementSibling;
      if (next && next.classList.contains('pp-order-note')) return;
      var p = document.createElement('p');
      p.className = 'pp-order-note';
      p.textContent = txt();
      t.insertAdjacentElement('afterend', p);
    });
  }
  function init() { injectCSS(); apply(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ─── FICHE PRODUIT : couleurs de pastilles manquantes (Silver / Gray) — sinon gris générique ───
(function () {
  var BG = {
    'Silver': 'linear-gradient(135deg,#eceef0 0%,#c6c9cd 48%,#aeb2b7 52%,#dfe1e4 100%)',
    'Gray': '#8E9296',
    'Grey': '#8E9296'
  };
  function apply() {
    document.querySelectorAll('.pp-swatch').forEach(function (b) {
      var v = b.dataset.value;
      if (BG[v]) b.style.background = BG[v];
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();

// ─── FICHE PRODUIT : guide des tailles localisé par langue (lot 8 : l'ancienne réécriture « 30 s » -> « 3 s » est retirée, la pose prend 30 s) ───
(function () {
  function fixSizeGuide() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    document.querySelectorAll('a[href*="strap-size-guide"]').forEach(function (a) {
      a.setAttribute('href', root + 'pages/strap-size-guide');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixSizeGuide);
  } else {
    fixSizeGuide();
  }
})();

// ─── FICHE PRODUIT : remonter la note d'avis (Judge.me) juste sous le titre (au-dessus de la ligne de flottaison mobile) ───
(function () {
  function injectCSS() {
    if (document.getElementById('pp-badge-top-css')) return;
    var s = document.createElement('style');
    s.id = 'pp-badge-top-css';
    s.textContent = '.pp-info .jdgm-widget.jdgm-preview-badge.pp-badge-top{margin:6px 0 2px;}';
    (document.head || document.documentElement).appendChild(s);
  }
  function move() {
    var info = document.querySelector('.pp-info');
    if (!info) return false;
    var h1 = info.querySelector('h1.pp-title');
    var badge = info.querySelector('.jdgm-widget.jdgm-preview-badge');
    if (!h1 || !badge) return false;
    if (h1.nextElementSibling !== badge) h1.insertAdjacentElement('afterend', badge);
    badge.classList.add('pp-badge-top');
    return true;
  }
  function init() {
    injectCSS();
    if (move()) return;
    var tries = 0;
    var t = setInterval(function () { tries++; if (move() || tries > 20) clearInterval(t); }, 200);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ─── FICHE PRODUIT : compte à rebours de l'offre -10% rendu PERPÉTUEL + localisé (remplace l'échéance figée) ───
(function () {
  var L = {
    fr: function (dd, h, m, s) { return '⏳ Offre limitée — fin dans ' + dd + 'j ' + h + 'h ' + m + 'm ' + s + 's'; },
    en: function (dd, h, m, s) { return '⏳ Limited offer — ends in ' + dd + 'd ' + h + 'h ' + m + 'm ' + s + 's'; },
    de: function (dd, h, m, s) { return '⏳ Begrenztes Angebot — endet in ' + dd + 'T ' + h + 'h ' + m + 'm ' + s + 's'; },
    nl: function (dd, h, m, s) { return '⏳ Beperkt aanbod — eindigt over ' + dd + 'd ' + h + 'u ' + m + 'm ' + s + 's'; }
  };
  function fmt() { return L[(document.documentElement.lang || 'en').slice(0, 2).toLowerCase()] || L.en; }
  function nextDeadline() {
    var now = new Date();
    var d = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 0);
    var add = (7 - d.getDay()) % 7;
    if (add === 0 && now.getTime() > d.getTime()) add = 7;
    d.setDate(d.getDate() + add);
    return d.getTime();
  }
  function drive(el) {
    var f = fmt();
    var end = nextDeadline();
    function tick() {
      var d = end - Date.now();
      if (d <= 0) { end = nextDeadline(); d = end - Date.now(); }
      var days = Math.floor(d / 86400000), h = Math.floor(d % 86400000 / 3600000), m = Math.floor(d % 3600000 / 60000), s = Math.floor(d % 60000 / 1000);
      el.textContent = f(days, h, m, s);
    }
    tick();
    setInterval(tick, 1000);
  }
  function init() {
    var old = document.getElementById('pp-bundle-timer');
    if (!old) return;
    var fresh = old.cloneNode(false);
    fresh.textContent = '';
    old.parentNode.replaceChild(fresh, old);
    drive(fresh);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();



// ─── SITE : fenêtre de retour 30 j → 90 j (hors corps légal .shopify-policy__container), 4 langues. Lot 8 : règles « 30 secondes → 3 secondes » retirées (la pose prend 30 secondes) ───
(function () {
  function inPolicy(node) { var p = node.parentElement; return !!(p && p.closest && p.closest('.shopify-policy__container, .shopify-policy__body')); }
  var MAP = [
    [/\b30\s+jours\b/g, '90 jours'],
    [/\b30-day\b/gi, '90-day'],
    [/\b30\s+days\b/gi, '90 days'],
    [/\b30\s+Tage\b/g, '90 Tage'],
    [/\b30\s+dagen\b/g, '90 dagen']
  ];
  function walk() {
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var nodes = [], n;
    while ((n = w.nextNode())) {
      if (n.nodeValue && /\b30[\s-](jours|day|days|Tage|dagen)/i.test(n.nodeValue) && !inPolicy(n)) nodes.push(n);
    }
    nodes.forEach(function (node) {
      var t = node.nodeValue;
      MAP.forEach(function (p) { t = t.replace(p[0], p[1]); });
      if (t !== node.nodeValue) node.nodeValue = t;
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', walk);
  } else {
    walk();
  }
})();
